<div class="im:card content-card" (click)="tap()">
  @if (pinned) {
    <div class="pin-icon-container">
      <rs-web-icon
        [color]="'contrast-color(var(--im-color-primary))'"
        [icon]="immomioIconName.Pin"
        [size]="16"
      ></rs-web-icon>
    </div>
  }

  <div [class.content-card__header--offer]="preset === presets.OFFER" class="content-card__header">
    @if (showImageSlot()) {
      <!-- The wrapper reserves the space; the image itself is only rendered once the source
           resolves, otherwise the browser paints its broken-image placeholder. -->
      <div class="content-card__header__image">
        @if (image()) {
          <rs-web-image
            [defaultSrc]="image()"
            [objectFit]="imageObjectFit"
            [borderRadius]="imageBoarderRadius"
            [borderStyle]="imageBorderStyle"
            [centerImage]="preset === presets.NEWS ? true : false"
            [dataTableCellPicture]="preset === presets.NEWS ? true : false"
            [centerImageSize]="preset === presets.NEWS ? centerImageSize : undefined"
          ></rs-web-image>
        }
      </div>
    }
    <span class="content-card__header__title primary-text">{{ title | translate }}</span>
  </div>
  <div class="content-card__body">
    <p
      [innerHtml]="removeHTML(text) | translate"
      [ngClass]="preset !== presets.OFFER ? 'secondary-text' : 'primary-text'"
      class="content-card__text"
    ></p>
  </div>
  @if (date) {
    <hr class="my-0 mx-3" />

    @let dateColor = 'var(--color-text-secondary, #193f70)';

    <div class="content-card__bottom">
      <rs-web-icon [size]="16" [icon]="footerIcon" [color]="dateColor"></rs-web-icon>
      <div [style.color]="dateColor">
        {{ date | rsWebDate }}
      </div>
    </div>
  }
</div>
